import React, { useEffect, useState } from 'react';
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../modal/confirmModal';
import { RATE_LIMIT_EVENT } from '../../services/api';

// "5 min 06 s" ou "45 s".
const formatWait = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  if (!minutes) return `${rest} s`;
  return `${minutes} min ${String(rest).padStart(2, '0')} s`;
};

// Aviso de limite de requisições (429). O backend trava por endpoint, então várias chamadas barradas
// ao mesmo tempo viram um aviso só, com a maior espera. Fica aberto até o usuário fechar.
function RateLimitNotice() {
  const [isOpen, setIsOpen] = useState(false);
  // Horário (ms) em que todas as chamadas barradas voltam a funcionar; 0 = backend não informou o tempo.
  const [availableAt, setAvailableAt] = useState(0);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const handleRateLimit = (event) => {
      const seconds = event.detail?.retryAfterSeconds;
      const nextAvailableAt = seconds ? Date.now() + seconds * 1000 : 0;
      setAvailableAt((current) => Math.max(current, nextAvailableAt));
      setNow(Date.now());
      setIsOpen(true);
    };

    window.addEventListener(RATE_LIMIT_EVENT, handleRateLimit);
    return () => window.removeEventListener(RATE_LIMIT_EVENT, handleRateLimit);
  }, []);

  // Contagem regressiva enquanto o aviso está aberto.
  useEffect(() => {
    if (!isOpen || !availableAt) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [isOpen, availableAt]);

  const handleClose = () => {
    setIsOpen(false);
    setAvailableAt(0);
  };

  const remainingSeconds = availableAt ? Math.max(0, Math.ceil((availableAt - now) / 1000)) : null;

  let message = 'Algumas informações ou ações desta tela foram barradas temporariamente por excesso de '
    + 'requisições. Aguarde alguns minutos e tente novamente.';
  if (remainingSeconds > 0) {
    message = 'Algumas informações ou ações desta tela foram barradas temporariamente por excesso de '
      + `requisições. Aguarde ${formatWait(remainingSeconds)} e tente novamente.`;
  } else if (remainingSeconds === 0) {
    message = 'O tempo de espera terminou. Atualize a página para carregar as informações novamente.';
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      icon={faHourglassHalf}
      mainMessage="Limite de requisições atingido"
      secondaryMessage={message}
      onConfirm={handleClose}
      closeModal={handleClose}
      confirmLabel="Entendi"
      showCancel={false}
    />
  );
}

export default RateLimitNotice;
